import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';

@Pipe({
  name: 'locationReconstructionOfExitApplicationParcelsSectionTitle',
  standalone: true
})
export class LocationReconstructionOfExitParcelsSectionTitlePipe implements PipeTransform {
  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (true) {
      case application?.applicationSubject === 'Przebudowy zjazdu': {
        return 'Działki drogowe na których jest zjazd';
      }
      default: {
        return 'Działki drogowe na których będzie projektowany zjazd';
      }
    }
  }
}
